import type { FunctionComponent } from 'react'
import React from 'react'

import classnames from 'classnames'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const LoansIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 50,
  height = 50,
  ...rest
}) => {
  return (
    <Icon fill={fill} height={height} viewBox={`0 0 ${width} ${height}`} width={width} {...rest}>
      <circle
        cx="29.6"
        cy="15.4"
        fill="#ffffff"
        r="14.2"
        stroke="#000000"
        className={classnames(styles.white, styles.defaultStrokeColor)}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="2"
      />
      <path
        d="M30.9 22.7h-6.5v-2.8c1.1 0 1.8-.7 1.8-1.9 0-.3 0-.5-.1-.7h-1.6v-1.8h1c-.4-.8-.7-1.6-.7-2.6 0-2.6 1.9-4.5 4.8-4.5s4.4 1.9 4.4 4.1c0 1-.3 1.7-.7 2.4l-2.6-1.1c.2-.3.4-.7.4-1.2 0-.9-.6-1.6-1.4-1.6-1 0-1.6.8-1.6 1.9 0 1.1.4 1.8.7 2.6h2.1v1.8h-1.7v.3c0 1-.7 1.9-1.5 2.3h3c1.3 0 1.9-.6 2-1.8l2 1.7c-.4 2-1.7 2.9-3.8 2.9z"
        fill="#E81C30"
        className={styles.accentColor}
      />
      <path
        d="M2 36.4s4.6-4.6 9.1-3.6 7.3 1.8 10.9 1.8h6.4s4.6.9 5.5.9c.9 0 2.7 0 4.6-.9 1.8-.9 3.6-3.6 5.5-3.6 1.8 0 4.6.9 3.6 3.6-.9 2.7-7.3 8.2-7.3 8.2s-3.6 4.6-8.2 4.6H10.2L2 36.4z"
        fill="#ffffff"
        className={styles.white}
      />
      <path
        d="M37.6 45.4 47 36c.6-.6.9-1.4.9-2.3 0-.9-.3-1.7-.9-2.3-1.3-1.3-3.3-1.3-4.6 0l-6 6c0 1.8-1.5 3.3-3.4 3.3h-8.6s-.1 0-.1-.1c0 0 0-.1.1-.1H33c1.8 0 3.3-1.5 3.3-3.3 0 0 0 0 0 0 0-1.8-1.5-3.3-3.3-3.3H19.6s0 0 0 0c-1.8-.9-3.5-1.5-6.3-1.5-5 0-9.4 3.6-11.3 5.5L9.3 47l7.1.1h16.5c1.8.3 3.5-.4 4.7-1.7l9.4-9.3c.6-.6 1-1.5 1-2.4 0-.9-.3-1.7-1-2.4-1.3-1.3-3.4-1.3-4.8 0l-6 6c-.1-1.8-1.5-3.2-3.4-3.2H19.6c-1.8-.9-3.6-1.5-6.3-1.5-5.1 0-9.1 3.2-11 5.1v.1"
        fill="#ffffff"
        stroke="#000000"
        className={classnames(styles.white, styles.defaultStrokeColor)}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="2"
      />
      <path
        d="M11.1 47.3c0 1-.8 1.8-1.8 1.8H3.8c-1 0-1.8-.8-1.8-1.8V32.7c0-1 .8-1.8 1.8-1.8h5.5c1 0 1.8.8 1.8 1.8M10.7 33.2v15.5"
        fill="#ffffff"
        stroke="#000000"
        className={classnames(styles.white, styles.defaultStrokeColor)}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="2"
      />
    </Icon>
  )
}
